export enum PerformerTypesEnum {
  Patient = 0,
  CareProvider = 1,
  Mother = 2,
  Father = 3,
  Teacher = 4,
  OtherRelative = 5,
  Other = 6,
  Parent = 7,
  ParentsTogether = 8,
  OtherGuardian = 9,
  PatientSelf = 10,
  PatientWithAssistanceOfOtherPerson = 11,
  CareProviderGuardianOrParent = 12,
  LoggedOnUser = 13,
  Agent = 14 // When for example a parent is performing on behalf of a child, the performer type will be set to Agent. Only used in the backend, will never be shown in the frontend as a performer type option.
}
